import React, { useState, useEffect } from "react";
import { Avatar, AvatarFallback } from "./ui/avatar";

const TestimonialsSection = () => {
  const [count, setCount] = useState(32317);
  const [showThumbsUp, setShowThumbsUp] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      // Random increment between 1-5
      const increment = Math.floor(Math.random() * 5) + 1;
      
      setCount(prevCount => prevCount + increment);
      
      // Show thumbs up animation
      setShowThumbsUp(true);
      
      // Hide thumbs up after animation
      setTimeout(() => {
        setShowThumbsUp(false);
      }, 800);
      
    }, 3000 + Math.random() * 2000); // Every 3-5 seconds randomly

    return () => clearInterval(interval);
  }, []);
  const testimonials = [
    {
      type: "linkedin",
      quote: "My boss actually thinks I grew a spine.",
      name: "Middle Manager",
      subtitle: "Operations, Ohio",
      avatar: "MM",
      engagement: "👍 54 · 💬 8 · 🔗 Share"
    },
    {
      type: "twitter",
      quote: "Better than therapy.",
      handle: "@TechBro420",
      username: "Tech Bro",
      avatar: "TB",
      engagement: "♥ 142 · 🔁 21"
    }
  ];

  return (
    <section className="py-20" style={{ backgroundColor: '#FFD60A' }}>
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-black text-black">
            Don't just take our word for it.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index} 
              className="bg-white border border-gray-200 rounded-xl p-6 hover:shadow-lg transition-shadow duration-300"
              style={{ borderColor: '#E5E7EB' }}
            >
              {/* Header */}
              <div className="flex items-center gap-4 mb-4">
                <Avatar className="w-12 h-12">
                  <AvatarFallback className="bg-gray-300 text-gray-700 text-base font-semibold">
                    {testimonial.avatar}
                  </AvatarFallback>
                </Avatar>
                <div className="flex-1">
                  {testimonial.type === 'twitter' ? (
                    <>
                      <div className="font-bold text-black text-base">{testimonial.handle}</div>
                      <div className="text-gray-500 text-sm">{testimonial.username}</div>
                    </>
                  ) : (
                    <>
                      <div className="font-bold text-black text-base">{testimonial.name}</div>
                      <div className="text-gray-500 text-sm">{testimonial.subtitle}</div>
                    </>
                  )}
                </div>
              </div>

              {/* Body */}
              <div className="mb-4">
                <p className={`text-gray-800 ${testimonial.type === 'twitter' ? 'text-base' : 'text-lg'}`}>
                  {testimonial.quote}
                </p>
              </div>

              {/* Footer */}
              <div className="text-gray-400 text-sm">
                {testimonial.engagement}
              </div>
            </div>
          ))}
        </div>

        {/* Live Counter */}
        <div className="text-center mt-16 max-w-2xl mx-auto relative">
          {/* Thumbs Up Animation */}
          <div 
            className={`absolute -top-8 left-1/2 transform -translate-x-1/2 text-2xl transition-all duration-800 ${
              showThumbsUp 
                ? 'opacity-100 -translate-y-4 scale-110' 
                : 'opacity-0 translate-y-0 scale-100'
            }`}
          >
            👍
          </div>
          
          {/* Counter Number - matching heading font */}
          <div className="text-4xl md:text-5xl lg:text-6xl font-black text-black mb-4 leading-tight">
            {count.toLocaleString()}
          </div>
          
          {/* Subtitle */}
          <p className="text-black text-lg md:text-xl font-medium">
            Weak words eliminated this week.
          </p>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;